export const ISSUE_STATUSES = {
    OPEN: 1,
    ON_HOLD: 2,
    IN_PROGRESS: 15,
    ESCALATED_TO_THIRD_PARTY: 5,
    WAITING_FOR_THIRD_PARTY: 6,
    ESCALATED_INTERNALLY: 17,
    ESCALATED_TO_PARTNER: 9,
    ACKNOWLEDGED_BY_PARTNER: 10,
    ETA_PROVIDED_BY_PARTNER: 11,
    PARTNER_TRAVELLING: 12,
    PARTNER_ON_SITE: 13,
    PARTNER_RESOLUTION: 14,
    WAITING_FOR_SUPPORT: 7,
    WAITING_FOR_CUSTOMER: 8,
    SOLVED: 3,
    CLOSED: 4,
    REOPENED: 16,
};

export const ISSUE_STATUS_TRANSLATIONS = {
    [ISSUE_STATUSES.OPEN]: 'constants.issueStatus.open',
    [ISSUE_STATUSES.ON_HOLD]: 'constants.issueStatus.onHold',
    [ISSUE_STATUSES.SOLVED]: 'constants.issueStatus.solved',
    [ISSUE_STATUSES.CLOSED]: 'constants.issueStatus.closed',
    [ISSUE_STATUSES.ESCALATED_TO_THIRD_PARTY]: 'constants.issueStatus.escalatedToThirdParty',
    [ISSUE_STATUSES.WAITING_FOR_THIRD_PARTY]: 'constants.issueStatus.waitingForThirdParty',
    [ISSUE_STATUSES.WAITING_FOR_SUPPORT]: 'constants.issueStatus.waitingForSupport',
    [ISSUE_STATUSES.WAITING_FOR_CUSTOMER]: 'constants.issueStatus.waitingForCustomer',
    [ISSUE_STATUSES.ESCALATED_TO_PARTNER]: 'constants.issueStatus.escalatedToPartner',
    [ISSUE_STATUSES.ACKNOWLEDGED_BY_PARTNER]: 'constants.issueStatus.acknowledgedByPartner',
    [ISSUE_STATUSES.ETA_PROVIDED_BY_PARTNER]: 'constants.issueStatus.etaProvidedByPartner',
    [ISSUE_STATUSES.PARTNER_TRAVELLING]: 'constants.issueStatus.partnerTravelling',
    [ISSUE_STATUSES.PARTNER_ON_SITE]: 'constants.issueStatus.partnerOnSite',
    [ISSUE_STATUSES.PARTNER_RESOLUTION]: 'constants.issueStatus.partnerResolution',
    [ISSUE_STATUSES.IN_PROGRESS]: 'constants.issueStatus.inProgress',
    [ISSUE_STATUSES.REOPENED]: 'constants.issueStatus.reopened',
    [ISSUE_STATUSES.ESCALATED_INTERNALLY]: 'constants.issueStatus.escalatedInternally',
};

export const ISSUE_PARTNER_STATUSES = [
    ISSUE_STATUSES.ESCALATED_TO_PARTNER,
    ISSUE_STATUSES.ACKNOWLEDGED_BY_PARTNER,
    ISSUE_STATUSES.ETA_PROVIDED_BY_PARTNER,
    ISSUE_STATUSES.PARTNER_TRAVELLING,
    ISSUE_STATUSES.PARTNER_ON_SITE,
    ISSUE_STATUSES.PARTNER_RESOLUTION,
];

export const ISSUE_INACTIVE_STATUSES = [ISSUE_STATUSES.SOLVED, ISSUE_STATUSES.CLOSED];

export const getIssueStatusOptions = statuses =>
    statuses.map(value => ({
        labelKey: ISSUE_STATUS_TRANSLATIONS[value],
        value: +value,
    }));

export const ISSUE_STATUS_OPTIONS = getIssueStatusOptions(Object.values(ISSUE_STATUSES));

export const ISSUE_STATUS_COLORS = {
    [ISSUE_STATUSES.OPEN]: 'DARK_BLUE',
    [ISSUE_STATUSES.ON_HOLD]: 'LIGHT_GREY',
    [ISSUE_STATUSES.SOLVED]: 'DARK_GREEN',
    [ISSUE_STATUSES.CLOSED]: 'DARK_GREEN',
    [ISSUE_STATUSES.ESCALATED_TO_THIRD_PARTY]: 'DARK_RED',
    [ISSUE_STATUSES.WAITING_FOR_THIRD_PARTY]: 'LIGHT_RED',
    [ISSUE_STATUSES.WAITING_FOR_SUPPORT]: 'LIGHT_BLUE',
    [ISSUE_STATUSES.WAITING_FOR_CUSTOMER]: 'LIGHT_GREY',
    [ISSUE_STATUSES.ESCALATED_TO_PARTNER]: 'DARK_RED',
    [ISSUE_STATUSES.ACKNOWLEDGED_BY_PARTNER]: 'LIGHT_BLUE',
    [ISSUE_STATUSES.ETA_PROVIDED_BY_PARTNER]: 'LIGHT_RED',
    [ISSUE_STATUSES.PARTNER_TRAVELLING]: 'LIGHT_GREY',
    [ISSUE_STATUSES.PARTNER_ON_SITE]: 'DARK_BLUE',
    [ISSUE_STATUSES.PARTNER_RESOLUTION]: 'DARK_GREEN',
    [ISSUE_STATUSES.IN_PROGRESS]: 'LIGHT_BLUE',
    [ISSUE_STATUSES.REOPENED]: 'DARK_BLUE',
    [ISSUE_STATUSES.ESCALATED_INTERNALLY]: 'LIGHT_GREY',
};
